var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { fancyTimeFormat } from '../lib';
import Tippy from '@tippyjs/react';
import { followCursor } from 'tippy.js';
import { FaPlay, FaPause, FaVolumeMute, FaVolumeUp, FaExpand, FaCompress, FaUndo } from 'react-icons/fa';
import { VideoControlsContainer, StyledIconButtonDiv, VideoSeekerContainer } from '../style';
var Controls = function (props) {
    var isPlaying = props.isPlaying, onSeek = props.onSeek, currentTime = props.currentTime, totalTime = props.totalTime, onPlayChange = props.onPlayChange, volume = props.volume, onVolumeChange = props.onVolumeChange, onFullscreenChange = props.onFullscreenChange, isEnded = props.isEnded, handleRePlay = props.handleRePlay;
    var _a = useState(false), isExpanded = _a[0], setIsExpanded = _a[1];
    var seekerPercent = currentTime / totalTime;
    var isMuted = volume === 0;
    var handleVolumeChange = function () {
        onVolumeChange(volume === 0 ? 1 : 0);
    };
    return (_jsxs(VideoControlsContainer, { children: [_jsx(VideoSeeker, { value: seekerPercent, duration: totalTime, onChange: onSeek, isEnded: isEnded }), _jsxs("div", __assign({ style: {
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0px 8px'
                } }, { children: [isEnded ? (_jsx(StyledIconButtonDiv, __assign({ onClick: function () {
                            handleRePlay();
                        } }, { children: _jsx(FaUndo, {}) }))) : (_jsxs(StyledIconButtonDiv, __assign({ onClick: function () {
                            onPlayChange();
                        } }, { children: [!isPlaying ? _jsx(FaPlay, {}) : _jsx(FaPause, {}), ' '] }))), _jsx(StyledIconButtonDiv, __assign({ onClick: handleVolumeChange }, { children: isMuted ? _jsx(FaVolumeMute, {}) : _jsx(FaVolumeUp, {}) })), _jsxs("div", __assign({ style: {
                            padding: '0 8px',
                            display: 'flex',
                            color: '#fff',
                            fontFamily: 'sans-serif'
                        } }, { children: [_jsx("div", { children: fancyTimeFormat(currentTime) }), _jsx("div", __assign({ style: {
                                    margin: '0 4px',
                                    whiteSpace: 'pre'
                                } }, { children: ' / ' })), _jsx("div", { children: fancyTimeFormat(totalTime) })] })), _jsx("div", { style: { flex: 1 } }), _jsx(StyledIconButtonDiv, __assign({ onClick: function () {
                            onFullscreenChange();
                            setIsExpanded(!isExpanded);
                        } }, { children: !isExpanded ? _jsx(FaExpand, {}) : _jsx(FaCompress, {}) }))] }))] }));
};
export default Controls;
var VideoSeeker = function (props) {
    var value = props.value, duration = props.duration, onChange = props.onChange, isEnded = props.isEnded;
    var baseBarStyle = {
        borderRadius: '8px',
        left: 8,
        right: 8,
        position: 'absolute',
        height: '3px',
        boxSizing: 'border-box'
    };
    var _a = useState(''), tooltipValue = _a[0], setTooltipValue = _a[1];
    var handleMouseMove = function (e) {
        var percent = Math.ceil(((e.clientX - 16) / (e.currentTarget.offsetWidth + 0)) * 100) /
            100;
        setTooltipValue("".concat(fancyTimeFormat(percent * duration)));
    };
    var handleClick = function (e) {
        var rect = e.currentTarget.getBoundingClientRect();
        var percent = Math.ceil(((e.clientX - rect.left) / (e.currentTarget.offsetWidth + 0)) * 10000) / 100;
        if (!isEnded) {
            onChange(percent);
        }
    };
    return (_jsxs(VideoSeekerContainer, __assign({ onMouseMove: handleMouseMove }, { children: [_jsx(Tippy, __assign({ delay: [100, 50], offset: [0, 16], content: _jsx("span", __assign({ style: {
                        padding: '6px 12px',
                        borderRadius: '8px',
                        backgroundColor: 'rgba(0,0,0,0.75)',
                        color: '#fff',
                        fontFamily: 'sans-serif',
                        marginBottom: '8px'
                    } }, { children: tooltipValue })), followCursor: "horizontal", plugins: [followCursor] }, { children: _jsx("div", { id: "tooltip-controller", style: __assign(__assign({}, baseBarStyle), { backgroundColor: '#FFF' }), onClick: handleClick }) })), _jsx("div", { style: __assign(__assign({}, baseBarStyle), { pointerEvents: 'none', width: "calc(".concat(Math.min(isEnded ? 1 : value, 1) * 100, "% - 16px)"), backgroundColor: isEnded ? 'grey' : '#F00' }) })] })));
};
//# sourceMappingURL=index.js.map